<script>
    import SVG from '../../Models/svgORM';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {confirm} from '../Confirmation.svelte';
    import {notifier} from '@beyonk/svelte-notifications';

    import {tables} from '../../lib/tables';
    import {forms} from '../../lib/forms';
    import { handleError } from '../../Utilities/handlePromise';

    function addImage() {
        addFormModal({
            fields: forms.SVG,
            title: "Add Image",
        }).then((data) => {
            SVG.createItem(data).then(() => {
                notifier.success("Image Added")
            }, handleError);
        }, handleError);
    }

    function editImage(image) {
        addFormModal({
            fields: forms.SVG,
            title: "Edit Image",
            data: image
        }).then(data => {
            SVG.save(data).then(() => {
                notifier.success("Image Saved")
            }, handleError);
        }, handleError);
    }

    function deleteImage(image) {
        confirm(`Are you sure you want to delete ${image.name}?`).then(() => {
            let image_ = new SVG(image._id);
            image_.delete().then(() => {
                notifier.success("Image Deleted")
            });
        }, handleError);
    }

    let SVGList = SVG.getList();
</script>

<Loader loading={!$SVGList}>
    <div class="container is-fluid">
        <h1 class="title is-1">Report Images</h1>
        <SortableTable sortFields={tables['SVG']} tableData={$SVGList}>
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addImage}>Add Image</button>
                </div>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addImage}>Add Image</button>
                </div>
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={image}>
                <button class="button is-info" on:click={() => editImage(image)}>Edit</button>
                <button class="button is-danger" on:click={() => deleteImage(image)}>Delete</button>
            </div>
        </SortableTable>
    </div>
</Loader>